import { memo } from 'react';
import { BankAccountView, SortParams, SortParamsArg, TableCells } from 'models';

import { PageTitle } from 'containers';
import { PageLoader, Error, Table } from 'components';

interface Props {
  handleChangeSortParams: (params: SortParamsArg) => void;
  bankAccounts: BankAccountView[];
  sortParams: SortParams;
  loading: boolean;
  error: boolean;
  tableCells: TableCells<any>[];
  title: string;
}

const BankAccountsDetails: React.FC<Props> = ({
  bankAccounts,
  sortParams,
  loading,
  error,
  tableCells,
  title,
  handleChangeSortParams,
}) => {
  if (loading) {
    return <PageLoader />;
  }

  if (error) {
    return <Error />;
  }

  return (
    <>
      <PageTitle />
      <Table
        list={bankAccounts}
        order={sortParams.order}
        orderBy={sortParams.orderBy}
        tableCells={tableCells}
        handleChangeSortParams={handleChangeSortParams}
      />
    </>
  );
};

export default memo(BankAccountsDetails);
